import { useEffect, useState } from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";

const Spotify = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Zm4.8 15.2a.7.7 0 0 1-.9.2c-2.6-1.6-5.8-1.9-9.6-1a.7.7 0 1 1-.3-1.3c4.2-1 7.7-.6 10.6 1.2.3.2.4.6.2.9Zm1.3-2.9a.9.9 0 0 1-1.2.3c-2.9-1.8-7.4-2.3-10.9-1.3a.9.9 0 1 1-.5-1.7c4-1.2 8.9-.6 12.3 1.5.4.3.5.8.3 1.2Zm.1-3c-3.5-2.1-9.3-2.3-12.6-1.3a1 1 0 1 1-.6-2c3.8-1.1 10.2-.9 14.2 1.5a1 1 0 0 1-1 1.8Z" /></svg>
);
const SoundCloud = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M1 14.5h.8v3H1zm2-1.5h.8v4.5H3zm2-1h.8v5.5H5zm2-1.5h.8v7H7zm2-.5h.8v7.5H9zm2-1.5c.4-.2.9-.3 1.4-.3a5 5 0 0 1 4.9 4.1 3 3 0 1 1 .7 5.7H11z" /></svg>
);

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M16.6 2h-3.3v13.2a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9a6.3 6.3 0 1 0 5.3 6.2V8.5a7.9 7.9 0 0 0 4.5 1.4V6.6a4.6 4.6 0 0 1-4.5-4.6Z" /></svg>
);

const ICONS = { tiktok: TikTok, spotify: Spotify, soundcloud: SoundCloud, instagram: Instagram, youtube: Youtube, facebook: Facebook };

export const useSocials = () => {
  const [links, setLinks] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setLinks(r.data?.socials ?? {})).catch(() => setLinks({}));
  }, []);
  return links;
};

export const SocialLinks = () => {
  const { t } = useT();
  const links = useSocials();

  const active = Object.keys(ICONS).filter((k) => links[k]);
  if (!active.length) return null;

  return (
    <div data-testid="social-links" className="mt-10">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#1FD1FF] mb-3 flex items-center gap-3">
        {t("social.follow")} <span className="h-px w-24 bg-gradient-to-r from-[#1FD1FF] to-transparent" />
      </p>
      <div className="flex items-center gap-3">
        {active.map((k) => {
          const Icon = ICONS[k];
          return (
            <a key={k} href={links[k]} target="_blank" rel="noopener noreferrer" aria-label={k} data-testid={`social-link-${k}`}
              className="w-11 h-11 grid place-items-center border border-white/15 text-white hover:text-black hover:bg-[#1FD1FF] hover:border-[#1FD1FF] hover:-translate-y-0.5 transition-[background-color,color,transform,border-color] duration-300">
              <Icon className="w-5 h-5" />
            </a>
          );
        })}
      </div>
    </div>
  );
};
